import type { MutableRefObject } from "react";
import { DeepgramStreamingEngine } from "./deepgramStreamingEngine";

/** Shared factory for append-only Deepgram burst sessions (bug report, Firefly PTT). */
export function createDeepgramAppendEngine(
  onAppendRef: MutableRefObject<(chunk: string) => void>,
  onStatus?: (status: string) => void,
): DeepgramStreamingEngine {
  return new DeepgramStreamingEngine({
    onStatus,
    onAppendText: (chunk: string) => onAppendRef.current(chunk),
  });
}
